/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DiscordRelayMessageMessageAuthor,
    DiscordRelayMessageMessageAuthorFromJSON,
    DiscordRelayMessageMessageAuthorFromJSONTyped,
    DiscordRelayMessageMessageAuthorToJSON,
} from './';

/**
 * 
 * @export
 * @interface DiscordRelayMessageMessage
 */
export interface DiscordRelayMessageMessage {
    /**
     * Discord message ID
     * @type {string}
     * @memberof DiscordRelayMessageMessage
     */
    id: string;
    /**
     * Discord channel ID
     * @type {string}
     * @memberof DiscordRelayMessageMessage
     */
    channelId: string;
    /**
     * Discord guild/server ID
     * @type {string}
     * @memberof DiscordRelayMessageMessage
     */
    guildId: string;
    /**
     * Message content
     * @type {string}
     * @memberof DiscordRelayMessageMessage
     */
    content: string;
    /**
     * Message timestamp
     * @type {Date}
     * @memberof DiscordRelayMessageMessage
     */
    timestamp: Date;
    /**
     * 
     * @type {DiscordRelayMessageMessageAuthor}
     * @memberof DiscordRelayMessageMessage
     */
    author: DiscordRelayMessageMessageAuthor;
    /**
     * 
     * @type {Array<object>}
     * @memberof DiscordRelayMessageMessage
     */
    attachments?: Array<object>;
    /**
     * 
     * @type {Array<object>}
     * @memberof DiscordRelayMessageMessage
     */
    embeds?: Array<object>;
    /**
     * 
     * @type {Date}
     * @memberof DiscordRelayMessageMessage
     */
    editedTimestamp?: Date | null;
}

export function DiscordRelayMessageMessageFromJSON(json: any): DiscordRelayMessageMessage {
    return DiscordRelayMessageMessageFromJSONTyped(json, false);
}

export function DiscordRelayMessageMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordRelayMessageMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'channelId': json['channelId'],
        'guildId': json['guildId'],
        'content': json['content'],
        'timestamp': (new Date(json['timestamp'])),
        'author': DiscordRelayMessageMessageAuthorFromJSON(json['author']),
        'attachments': !exists(json, 'attachments') ? undefined : json['attachments'],
        'embeds': !exists(json, 'embeds') ? undefined : json['embeds'],
        'editedTimestamp': !exists(json, 'editedTimestamp') ? undefined : (json['editedTimestamp'] === null ? null : new Date(json['editedTimestamp'])),
    };
}

export function DiscordRelayMessageMessageToJSON(value?: DiscordRelayMessageMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'channelId': value.channelId,
        'guildId': value.guildId,
        'content': value.content,
        'timestamp': (value.timestamp.toISOString()),
        'author': DiscordRelayMessageMessageAuthorToJSON(value.author),
        'attachments': value.attachments,
        'embeds': value.embeds,
        'editedTimestamp': value.editedTimestamp === undefined ? undefined : (value.editedTimestamp === null ? null : value.editedTimestamp.toISOString()),
    };
}


